<template lang='pug' src='./block-img-box.pug'></template>

<script>
export default {
  props: {
    content: {
      Type: Object,
      default: () => {}
    },
    backgroundsize: {
      Type: String,
      default: 'cover'
    },
    backgroundrepeat: {
      Type: String,
      default: 'no-repeat'
    },
    backgroundposition: {
      Type: String,
      default: 'center'
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-img-box.vue?89dc3bb6